export default {
    getProjects: `/assignments/`,
    // ini nnti ubah ke member assignments yah :>
    // belom ngerti biar masuk ke middle ware nya gmn soal nya huehuehue
  };